import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const UpdateBlockModal = ({ show, onClose, data, refreshTable }) => {
  const [blockRooms, setBlockRooms] = useState("");
  const [newBlockRoom, setNewBlockRoom] = useState("");
  const [blockFromDate, setBlockFromDate] = useState("");
  const [blockToDate, setBlockToDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [blockRoomId, setBlockRoomId] = useState("");
  const [customerName, setCustomerName] = useState("");

  useEffect(() => {
    if (data) {
      // console.log('data is', data)
      setBlockRooms(data.BlockRooms || "");
      setBlockFromDate(data.blockFromDate ? data.blockFromDate.slice(0, 10) : "");
      setBlockToDate(data.blockToDate ? data.blockToDate.slice(0, 10) : "");
      setRemarks(data.remarks || data.Remarks || "");
      setCustomerName(data.customerName || data.CustomerName || "");
      setNewBlockRoom(data.newBlockRoom || "");
      setBlockRoomId(data.BookingRefNo || "");
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      const payload = {
        hotelId: data.hotelId,
        roomTypeId: data.roomTypeId,
        blockRoomId,
        newBlockRoom,
        blockRooms,
        blockFromDate,
        blockToDate,
        remarks,
        customerName,
      };

      const response = await axios.patch(
        `${REACT_APP_API_URL}api/dashboard/admin/room-blocking/edit`,
        payload
      );

      if (response.status === 200) {
        alert("Block updated successfully!");

        refreshTable();
        onClose();
      } else {
        alert("Failed to update block");
      }
    } catch (error) {
      console.error("Error updating block:", error);
      alert("Error updating block");
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal show fade admin-modal"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <form className="modal-content shadow-lg" onSubmit={handleSubmit}>
          <div className="modal-header">
            <div>
              <h5 className="modal-title mb-0">Update Block</h5>
              <div className="text-muted small">Adjust the blocked room details.</div>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Block From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={blockFromDate}
                  onChange={(e) => setBlockFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">Block To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={blockToDate}
                  onChange={(e) => setBlockToDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Total Blocked Rooms</label>
                <input
                  type="number"
                  id="blockRooms"
                  className="form-control"
                  value={blockRooms}
                  min={newBlockRoom}
                  onChange={(e) => setBlockRooms(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Newly Blocked Rooms</label>
                <input
                  type="number"
                  id="newBlockRoom"
                  className="form-control"
                  value={newBlockRoom}
                  min="1"
                  onChange={(e) => setNewBlockRoom(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">Customer Name</label>
                <input
                  type="text"
                  id="customerName"
                  className="form-control"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-12">
                <label className="form-label fw-semibold">Remarks</label>
                <input
                  type="text"
                  id="remarks"
                  className="form-control"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateBlockModal;
